<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap class="custom-mb">
            <v-flex sm12>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>Edit Equipment Type</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <router-link class="link-btn square-btn" :to="{name: 'EquipmentsList'}">
                            <v-icon color="black" medium>fa-chevron-left</v-icon>
                        </router-link>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-form class="ldmx-form">
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Code *" v-model="form.code" :maxlength="32" v-validate="{required: form.code, max: 32,'restrictedWord':[]}" data-vv-name="code" placeholder="" :error-messages="errors.collect('code')" required>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Name *" v-model="form.name" :maxlength="32" v-validate="{required: form.name, max: 32,'restrictedWord':[]}" data-vv-name="name" placeholder="" :error-messages="errors.collect('name')">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg12 md12 xs12>
                                        <v-textarea label="Description" v-model="form.description" data-vv-name="description" placeholder="" v-validate="{'restrictedWord':[]}" :error-messages="errors.collect('description')">
                                        </v-textarea>
                                    </v-flex>
                                    <v-flex lg12 md12 xs12>
                                        <v-switch label="Primary" v-model="form.primary"></v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <hr>
                            <div class="form-btn text-xs-right">
                                <v-btn color="gray white--text" @click="$router.push('/equipments/list')"><v-icon color="white">fa-times-circle</v-icon>Cancel</v-btn>
                                <v-btn color="green white--text" @click="submit">Save </v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import GoogleAds from "@/pages/widgets/GoogleAds";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
export default {
    $_veeValidate: {
        validator: "new"
    },
    components: {
        breadcrumbs,
        GoogleAds
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        } else {
            if (this.canLeaveWithoutPrompt) {
                return next();
            }
            next(window.confirm('Do you really want to leave? You have unsaved changes!'));
        }
    },
    data: () => ({
        equipmentId: null,
        canLeaveWithoutPrompt: false,
        breadcrumbs: [{
                name: 'Dashboard',
                to: "/dashboard",
                disabled: false
            },
            {
                name: 'Reporting',
                to: "/comingsoon",
                disabled: false
            },
            {
                name: 'Equipment Types',
                to: "/equipments/list",
                disabled: false
            },
            {
                name: 'Edit Equipment Type',
                disabled: true
            }
        ],
        form: {
            code: "",
            name: "",
            description: "",
            primary: false
        }
    }),
    mounted() {
        this.$validator.localize("en", this.dictionary);
        this.equipmentId = this.$route.query.id;
        if (!this.equipmentId) {
            alert("Invalid Equipment ID or no ID provided");
            this.$router.push("/equipments/list");
        } else {
            this.getEquipmentDetails();
        }
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        getEquipmentDetails() {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            services
                .post("equipments/equipmentById", {
                    id: self.equipmentId
                }, {
                    Authorization: "Bearer " + this.$store.state.user.token
                })
                .then(res => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    if (res.status === 200) {
                        const eqDetails = res.data.data.EquipmentTypes;
                        if (eqDetails) {
                            self.form = Object.assign(eqDetails);
                        }
                    }
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, 'red');
                    self.canLeaveWithoutPrompt = true;
                    self.$router.push("/equipments/list");
                });
        },
        submit() {
            const self = this,
                wApp = window.getApp;
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (isValid) {
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        services
                            .put(
                                "equipments/edit", self.form, {
                                    Authorization: "Bearer " + this.$store.state.user.token
                                }
                            )
                            .then(res => {
                                if (res.status === 200) {
                                    const isErr = res.data.is_error;
                                    self._showToast(res.data.message, isErr ? 'red' : 'green');
                                    wApp.$emit("showLoader", {
                                        show: false
                                    });
                                    if (isErr) {
                                        return;
                                    }
                                    self.canLeaveWithoutPrompt = true;
                                    self.$router.push("/equipments/list");
                                }
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, 'red');
                            });
                    }
                })
                .catch(err => {});
        },
        clear() {
            this.form = {};
            this.$validator.reset();
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/equipment/Edit.vue